import { BffBrandType, BffFacilityScheduleType } from '@src/lib/__generated/beffe/sdk';
import { getBeffeGraphQlClient } from '@src/lib/client';

export const getBffFacilitiesScheduleType = async (brand: BffBrandType, url: string) =>
	getBeffeGraphQlClient(url)
		.query<{ facilitiesScheduleType: BffFacilityScheduleType[] }>(
			`
				query GetFacilitiesScheduleType($brand: BffBrandType!) {
					facilitiesScheduleType(brand: $brand) {
						id
            scheduleType
					}
				}
			`,
			{ brand }
		)
		.toPromise();
